var customerLevel = "free"; // free, basic or pro

//var stripe = Stripe('pk_test_oTBdaj3DiPoh2GN2LRP6bgzS');
var stripe = Stripe('pk_live_2xaQxOvCEelcE2SQvmCtWQac');

var elements = stripe.elements();

var userAccountRef = null;

function initializeStripe() {
    // Custom styling can be passed to options when creating an Element.
    var style = {
      base: {
        // Add your base input styles here. For example:
        fontSize: '20px',
        color: "#32325d",
      }
    };

    if (typeof elements === 'undefined') {
        console.log("unable to create Stripe Card in initializeStripe(). elements undefined")
        return;
    }
    // Create an instance of the card Element.
    var card = elements.create('card', {style: style});

    if (typeof card === 'undefined') {
        console.log("unable to create Stripe Card in initializeStripe(). card undefined")
        return;
    }

    // Add an instance of the card Element into the `card-element` <div>.
    card.mount('#card-element');

    card.addEventListener('change', function(event) {
        var displayError = document.getElementById('card-errors');
        if (event.error) {
            displayError.textContent = event.error.message;
        } else {
            displayError.textContent = '';
        }
    });

    // Create a token or display an error when the form is submitted.
    var form = document.getElementById('payment-form');
    form.addEventListener('click', function(event) {
        event.preventDefault();
        stripe.createToken(card).then(function(result) {
            if (result.error) {
                // Inform the customer that there was an error.
                var errorElement = document.getElementById('card-errors');
                errorElement.textContent = result.error.message;
                console.log(result.error.message);
            } else {
                // Send the token to your server.
                stripeTokenHandler(result.token);
                console.log(result.token);
            }
        });
    });
}

function stripeTokenHandler(token) {
  // Insert the token ID into the form so it gets submitted to the server

  $('#submit-payment-spinner').removeClass('hidden');
  $('#submit-payment-button').prop('disabled', true);

  var form = document.getElementById('payment-form');
  var hiddenInput = document.createElement('input');
  hiddenInput.setAttribute('type', 'hidden');
  hiddenInput.setAttribute('name', 'stripeToken');
  hiddenInput.setAttribute('value', token.id);
  form.appendChild(hiddenInput);

  // Submit the form
  //form.submit();

  var user = firebase.auth().currentUser;
  var uid = user.uid;
  var email = user.email;
  var tok = token.id;
  var card = token.card.id;

  var dict = {uid: uid, email: email, token: tok, card: card};


  ga('send', 'event', 'Accounts', 'submit payment', 'Customer submitted payement');

  firebase.auth().currentUser.getIdToken().then(function(token) {
      $.ajax({
          url:'https://us-central1-webstructrual.cloudfunctions.net/subscription',
          type:'POST',
          data:JSON.stringify(dict),
          contentType:"application/json; charset=utf-8",
          dataType:"json",
          headers: { "Authorization": "Bearer " + token },
          success: function(data){
              $('#submit-payment-button').prop('disabled', false);
              $('#submit-payment-spinner').addClass('hidden');
              $("#subscribe-response-error").addClass('hidden');
              $("#subscribe-response-error").html("");
              //console.log(data);
              // firebase login...
              // addUserAccountDatastoreListener should be connected but just
              // in case, we explicitly update the view here.
              var user = firebase.auth().currentUser;
              onLoginSuccess(user);
              ga('send', 'event', 'Accounts', 'payment succeeded', 'Stripe success');
          },
          error: function (xhr, ajaxOptions, thrownError) {
              //console.log(xhr.responseText);
              $('#submit-payment-button').prop('disabled', false);
              $('#submit-payment-spinner').addClass('hidden');
              $("#subscribe-response-error").removeClass('hidden');
              $("#subscribe-response-error").html(xhr.responseText);
              ga('send', 'event', 'Accounts', 'payment failed', 'Stripe failed');
          }
      });
  });
}

function addUserAccountDatastoreListener() {
    var user = firebase.auth().currentUser;
    userAccountRef = firebase.database().ref('users/' + user.uid);
    userAccountRef.on('value', function(snapshot) {
        onLoginSuccess(user);
    });
}

function initializeFirebaseAuth() {

    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)

    firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
            onLoginSuccess(user);
            checkStripeSubscription();
        } else {
            onLogoutSuccess();
        }
    });
}

function openSignupModal() {
    $('#modal-sign-up-error').addClass('hidden');
    $('#modal-sign-up-form').modal('show');
}

function openSigninModal() {
    $('#modal-sign-in-error').addClass('hidden');
    $('#modal-login-form').modal('show');
}

function openForgotPasswordModal() {
    $('#modal-forgot-password-form').modal('show');
}

function openFinishUpgradeModal() {
    $('#modal-finish-upgrade').modal('show');
}

function login() {
    var email = $('#sign-in-email').val().trim();
    var password = $('#sign-in-password').val().trim();

    $('#login-wait-spinner').removeClass('hidden');

    // firebase login...
    firebase.auth().signInWithEmailAndPassword(email, password)
    .then(function(response) {
        onLoginSuccess(response.user);
    })
    .catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        var str = errorMessage;
        if(errorCode === 'auth/wrong-password') {
            str = 'Invalid password.';
        }
        $('#modal-sign-in-error').removeClass('hidden');
        $('#modal-sign-in-error').html(str);
        $('#login-wait-spinner').addClass('hidden');

    });
}

function logout() {
    removeProjectDatastoreListener();

    firebase.auth().signOut().then(function() {
        onLogoutSuccess();
    }).catch(function(error) {
        // An error happened.
    });
}

function signup() {
    var firstLast = $('#sign-up-first-last').val().trim();
    var email = $('#sign-up-email').val().trim();
    var password = $('#sign-up-password').val().trim();

    $('#sign-up-wait-spinner').removeClass('hidden');

    firebase.auth().createUserWithEmailAndPassword(email, password).then(function(user) {
        var user = firebase.auth().currentUser;
        createUser(user, firstLast);
        $('#sign-up-wait-spinner').addClass('hidden');
        return;
        // redirect to account page ...
        //window.location.replace("account.html");
    }, function(error) {
        var errorCode = error.code;
        var errorMessage = error.message;
        $('#modal-sign-up-error').removeClass('hidden');
        $('#modal-sign-up-error').html(errorMessage);
        $('#sign-up-wait-spinner').addClass('hidden');
    }).then(function() {
      // redirect to account page ...
      console.log("user created now redirect");
      //window.location.replace("account.html");
    });
}

function sendForgotPasswordEmail() {
    $('#forgot-password-wait-spinner').removeClass('hidden');
    var email = $('#forgot-password-email').val().trim();
    firebase.auth().sendPasswordResetEmail(email).then(function() {
        // Email sent.
        $('#forgot-password-wait-spinner').addClass('hidden');
        $('#modal-forgot-password-form').modal('hide');
        $('#modal-forgot-password-email-sent').modal('show');
        // show toast "A reset link has been emailed"
    }).catch(function(error) {
        // An error happened.
        var errorCode = error.code;
        var errorMessage = error.message;
        $('#forgot-password-wait-spinner').addClass('hidden');
        $('#modal-forgot-password-error').html(errorMessage);
    });
}

function resendVerifyEmailLink() {
    var user = firebase.auth().currentUser;

    user.sendEmailVerification().then(function() {
        // Email sent.
        $('#modal-verify-email').modal('hide');
        $('#modal-verify-email-sent').modal('show');
    }).catch(function(error) {
        // An error happened.
        alert('Verification email could not be sent. Please try again later.');
    });
}

function createUser(user, name) {
    firebase.auth().currentUser.sendEmailVerification().then(function() {
        // Email sent.
    }, function(error) {
        // An error happened.
    });

    // make a user entry in the database
    firebase.database().ref('users/' + user.uid).set({
        username: name
    })
    .then(function(docRef) {
        $('#modal-sign-up-form').modal('hide');
    })
    .catch(function(error) {
        console.error("Error adding document: ", error);
    });
}

function onLoginSuccess(user) {
    ga('set', 'userId', user.uid);
    ga('send', 'event', 'Accounts', 'login', 'Customer logged in');

    customerLevel = "basic";
    $('#modal-login-form').modal('hide');
    $('#modal-sign-up-form').modal('hide');
    $('#modal-finish-upgrade').modal('hide');
    $('#modal-sign-up-error').addClass('hidden');
    $('#modal-sign-in-error').addClass('hidden');
    $('#login-wait-spinner').addClass('hidden');
    // if logged in and paying add datastore listener and configure logged in and paying

    firebase.database().ref('/subscriptions/' + user.uid).once('value').then(function(snapshot) {
        if(snapshot.val() !== null && snapshot.val().isPaying === true) {
            customerLevel = "pro";
            configureLoggedInAndUpgraded();
        } else {
            configureLoggedInButNeedsUpgrade();
        }
    });

    //if(user.emailVerified == false) {
    //    $('#modal-verify-email').modal('show');
    //}
}

function checkStripeSubscription() {
    // check stripe subscription
    console.log("*** --- checking subscription --- ***")
    firebase.auth().currentUser.getIdToken().then(function(token) {
        $.ajax({
            url:'https://us-central1-webstructrual.cloudfunctions.net/checkSubscription',
            type:'POST',
            contentType:"application/json; charset=utf-8",
            dataType:"text",
            headers: { "Authorization": "Bearer " + token },
            success: function(data){
                console.log("*** --- success: checking subscription --- ***")
                configureLoggedInAndUpgraded();
            },
            error: function (xhr, ajaxOptions, thrownError) {
                console.log("*** --- faile: checking subscription --- ***")
                customerLevel = "basic";
                configureLoggedInButNeedsUpgrade();
                console.log(xhr.status);
                console.log(xhr.responseText);
            }
        });
    });
}

function onLogoutSuccess() {
    customerLevel = "free"
    configureLoggedOut();
    $('#modal-logout-form').trigger('on-logout-success');
}

function configureLoggedInAndUpgraded() {
    $('#customer-nav-items').removeClass('hidden');
    $('#visitor-nav-items').addClass('hidden');
    $('#upgrade-list-item').addClass('hidden');
    $('#project-list').removeClass('hidden');
    $('#brand-version-badge').html('Pro');
    $('#signed-in-as').removeClass('hidden');
    $('#signed-in-as').html('Pro Customer');
    $('#upgrade-now-row').addClass('hidden');
    $('#finish-upgrade-list-item').addClass('hidden');
    $('#project-list-group').removeClass('hidden');
    $("#upgrade-info").addClass('hidden');
    $("#welcome-message").addClass('hidden');
    var userId = firebase.auth().currentUser.uid;
    firebase.database().ref('/users/' + userId).once('value').then(function(snapshot) {
        var userDict = snapshot.val();
        if(userDict !== null && "username" in userDict) {
            $('#signed-in-as').html(snapshot.val().username);
        }
        getProjectsFromDatabaseAndUpdateProjectList();
        if(snapshot.val().companyName) {
            companyName = snapshot.val().companyName;
            document.getElementById("your-company-name").innerHTML = companyName;
        }
    });

    document.title = 'WebStructural - Professional Beam Design';
    // get rid of ads
    $('#top-ads').addClass('hidden');
    $('#middle-ads').addClass('hidden');
    // make printing work...
    $('#design-summary-div').removeClass('hidden-print');
    $('#beam-reactions-table').removeClass('hidden-print');
    $('#plots-div').removeClass('hidden-print');
    $('#numerical-results-div').removeClass('hidden-print');
    $('#results-view-div').removeClass('hidden-print');
    $('#footer').addClass('hidden-print');
    $('#modal-login-form').trigger('on-login-success');
}

function configureLoggedInButNeedsUpgrade() {
    $('#customer-nav-items').removeClass('hidden');
    $('#visitor-nav-items').addClass('hidden');
    $('#upgrade-list-item').addClass('hidden');
    $('#project-list').addClass('hidden');
    $('#brand-version-badge').html('Basic');
    $('#signed-in-as').removeClass('hidden');
    $('#signed-in-as').html('Basic Customer');
    $('#upgrade-now-row').removeClass('hidden');
    $('#finish-upgrade-list-item').removeClass('hidden');
    $('#project-list-group').addClass('hidden');
    $("#welcome-message").addClass('hidden');
    var userId = firebase.auth().currentUser.uid;
    firebase.database().ref('/users/' + userId).once('value').then(function(snapshot) {
        var userDict = snapshot.val();
        if(userDict !== null && "username" in userDict) {
            $('#signed-in-as').html(snapshot.val().username + '<i class="fa fa-fw fa-info-circle text-danger"></i>');
        }
    });
    document.title = 'WebStructural - Free Steel Beam Design';
    // show ads
    $('#top-ads').removeClass('hidden');
    $('#middle-ads').removeClass('hidden');
    // disable printing...
    $('#design-summary-div').addClass('hidden-print');
    $('#beam-reactions-table').addClass('hidden-print');
    $('#plots-div').addClass('hidden-print');
    $('#numerical-results-div').addClass('hidden-print');
    $('#results-view-div').addClass('hidden-print');
    $('#footer').removeClass('hidden-print');
    $('#modal-finish-upgrade').modal('show');
}

function configureLoggedOut() {
    $('#customer-nav-items').addClass('hidden');
    $('#visitor-nav-items').removeClass('hidden');
    $('#upgrade-list-item').removeClass('hidden');
    $('#project-list').addClass('hidden');
    $('#brand-version-badge').html('Basic');
    $('#signed-in-as').addClass('hidden');
    $('#upgrade-now-row').addClass('hidden');
    $('#finish-upgrade-list-item').addClass('hidden');
    $("#welcome-message").removeClass('hidden');
    document.title = 'WebStructural - Free Steel Beam Design';
    // show ads
    $('#top-ads').removeClass('hidden');
    $('#middle-ads').removeClass('hidden');
    // disable printing...
    $('#design-summary-div').addClass('hidden-print');
    $('#beam-reactions-table').addClass('hidden-print');
    $('#plots-div').addClass('hidden-print');
    $('#footer').removeClass('hidden-print');
    $('#numerical-results-div').addClass('hidden-print');
    $('#results-view-div').addClass('hidden-print');
    $('#project-list-group').addClass('hidden');
    $("#upgrade-info").removeClass('hidden');
}
